import React from 'react';
import { useI18n } from '../../../../../../../data/hooks/i18nHooks';
import styles from './EmptyLeadsList.module.scss';

function EmptyLeadsList(props) {
    const {} = props,
        i18n = useI18n(),
        message = i18n['label.no-leads-listed-at-the-moment'].split('.').map((s, i) => <p key={i}>{s}</p>);

    return <div className={styles.EmptyLeadsList}>{message}</div>;
}

export default EmptyLeadsList;
